@let surveyModel = $surveyModel();
@let transitions = $transitions();

<kendo-stacklayout orientation="horizontal" [align]="{ vertical: 'middle' }">
  <div id="manage-panel-header-meta">
    <h2>{{ $headerMeta() }}</h2>
    @let status = $currentStatus();
    @if (status) {
      <unity-chip-workflow-state-shared class="workflow-chip" [name]="status.name" [value]="status.enum_value" />
    }
  </div>
  <div id="manage-panel-edit">
    @if ($isEditable() === true && $isEditing() === false) {
      <button kendoButton themeColor="base" class="tool-button" type="button" [svgIcon]="editIcon" (click)="handleEdit()">Edit</button>
    }
  </div>
</kendo-stacklayout>
<kendo-card width="auto" class="general-card">
  <kendo-card-body>
    @if (surveyModel) {
      <unity-stepper-survey-shared [isLoading]="false" [surveyModel]="surveyModel" (pageChangeEvent)="onPageChangeEvent($event)">
        <ng-container form-response-survey>
          <survey [model]="surveyModel" />
        </ng-container>
      </unity-stepper-survey-shared>
    }
  </kendo-card-body>
  <kendo-card-footer class="response-footer">
    <kendo-stacklayout orientation="horizontal" [gap]="5" [align]="{ horizontal: 'end' }">
      <unity-chip-audit-popup-shared class="audit-data" [data]="$resource()" />
      @if ($isEditing() === true) {
        @let isSaving = $isSaving();
        <button kendoButton type="button" themeColor="error" [svgIcon]="cancelIcon" [disabled]="isSaving" (click)="handleCancel()">
          Cancel
        </button>
        @if ($showSubmit()) {
          <button
            themeColor="secondary"
            kendoButton
            title="SaveButton"
            type="button"
            [svgIcon]="saveIcon"
            [disabled]="isSaving"
            (click)="handleSave()">
            Save
          </button>
          @for (action of transitions; track action.id) {
            <button
              type="button"
              kendoButton
              themeColor="secondary"
              [svgIcon]="saveIcon"
              [disabled]="isSaving"
              (click)="handleSave(action)">
              {{ action.name }}
            </button>
          }
        }
        @if (isSaving === true) {
          <kendo-loader id="submit-loading" type="infinite-spinner" size="small" themeColor="info" />
        }
      }
    </kendo-stacklayout>
  </kendo-card-footer>
</kendo-card>
